import { RecommendationFeed } from "@/components/control-tower/RecommendationFeed";
import type { Building } from "@/lib/api/building";
import { PotentialVsRealizedCard } from "./PotentialVsRealizedCard";

/**
 * StrategyPortfolio — strategia-tason perspektiivi at kanta/salkku: säästöpotentiaali
 * vs. toteutunut first (same order as building-scope Säästöpotentiaali → Suositukset),
 * then the scoped StrategyProposal queue (same RecommendationFeed as /recommendations).
 */
export function StrategyPortfolio({ buildings }: { buildings: Building[] }) {
  return (
    <div className="space-y-6">
      <PotentialVsRealizedCard />
      <RecommendationFeed buildings={buildings} />
    </div>
  );
}
